import React, { useEffect, useState } from "react";
import banner from "../Assets/Images/homebanner.jpg";
import { Link } from "react-router-dom";
import ApiRequest from "../Common/restservice";
function News() {
  const [news, setNews] = useState([]);
  useEffect(() => {
    GetNews();
  }, []);
  const GetNews = async () => {
    let res = await ApiRequest("news.asp", "GET", null, {
      Authorization: localStorage.getItem("token"),
    });
    if (res.status === "error") {
      //   errorToast(res.message);
      return;
    }
    console.log(res.items);
  };
  return (
    <>
      <section>
        <div
          className="bannerimg cover-image bg-background3"
          data-bs-image-src={banner}
          style={{ background: `url(${banner}) center 25%` }}
        >
          <div className="header-text mb-0">
            <div className="container">
              <div className="text-center text-white">
                <h1>Blogs</h1>
                <ol className="breadcrumb text-center">
                  <li className="breadcrumb-item">
                    <Link to={"/"}>Home</Link>
                  </li>
                  <li className="breadcrumb-item active text-white">Blogs</li>
                </ol>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section class="sptb bg-white">
        <div class="container">
          <div class="section-title center-block text-center">
            <h2>Blogs</h2>
          </div>
          <div>
            
            {news.map((item, index) => {
              return <div key={index}>
                <h3>{item.title}</h3>
                <p>{item.message}</p>;
              </div>
            })}
          </div>
        </div>
      </section>
    </>
  );
}

export default News;
